import { authHeader, accountHeader, BASE_URL, handleResponse } from '@helpers/api';
import { ProductEvent } from '@constants/product-events';
import { captureOnCreate } from '@helpers/product-events';

function get(page, pageSize) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };
    return fetch(`${BASE_URL}api/messaging/campaigns/one-time?page=${page}&pageSize=${pageSize}`, requestOptions).then(
        handleResponse,
    );
}

function createOrUpdateCampaign(data) {
    const requestOptions = {
        method: 'PUT',
        headers: authHeader(),
        body: JSON.stringify(data),
    };

    return fetch(`${BASE_URL}api/messaging/campaigns/one-time`, requestOptions)
        .then(handleResponse)
        .then(captureOnCreate(data, ProductEvent.CampaignCreated, () => ({ message_type: data.messageType })));
}

function getSelectedContactsNumber(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data),
    };

    return fetch(`${BASE_URL}api/messaging/campaigns/getContactsCount`, requestOptions).then(handleResponse);
}

function deleteCampaign(id) {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader(),
    };

    return fetch(`${BASE_URL}api/messaging/campaigns/${id}`, requestOptions).then(handleResponse);
}

function uploadEmailCampaignImage(data) {
    const user = JSON.parse(localStorage.getItem('user'));
    const requestOptions = {
        method: 'POST',
        headers: {
            Authorization: 'Bearer ' + user.token,
            ...accountHeader(),
        },
        body: data,
    };
    return fetch(`${BASE_URL}api/messaging/campaigns/upload-asset`, requestOptions).then(handleResponse);
}

export const campaignsService = {
    get,
    createOrUpdateCampaign,
    getSelectedContactsNumber,
    deleteCampaign,
    uploadEmailCampaignImage,
};
